import React from "react";
import { View, StyleSheet, Text, TouchableOpacity } from "react-native";

import { LinearGradient } from "expo-linear-gradient";

export default function Settings(props) {
  return (
    <TouchableOpacity
      style={{
        margin: "3%",
      }}
      onPress={() => props.onPress()}
    >
      <LinearGradient
        // Button Linear Gradient
        colors={["#022b41", "#005067"]}
        style={{
          height: 60,
          alignItems: "center",
          borderRadius: 25,
          justifyContent: "center",
        }}
      >
        <Text
          style={{
            backgroundColor: "transparent",
            fontSize: 20,
            color: "white",
          }}
        >
          {props.title}
        </Text>
      </LinearGradient>
    </TouchableOpacity>
  );
}
